import React, { useState } from 'react';

import { InfiniteList, OrderItem } from '../../components';
import { OrderManagementProvider, OrderFlow } from '../../orderManagement';

import './order-list.scss';

const OrderList = ({ user }) => {
  const [key, setKey] = useState(0);
  const [order, setOrder] = useState(null);

  const openModal = (item, order) => {
    setOrder(order);
  };

  const closeModal = () => {
    setKey((key) => key + 1);
    setOrder(null);
  }

  return (
    <div className="mx-2">
      <InfiniteList
        key={key}
        className="orders user-orders"
        fetchUrl={`/api/user/${user.id}/orders/own`}
        fetchLimit={100}
        emptyText={`${user.first_name} has not made any orders yet.`}
        ItemComponent={OrderItem}
        itemProps={{
          hideActionButton: true,
          onItemClick: openModal,
        }}
      />

      <OrderManagementProvider
        client={user}
        editingOrder={order}
        closeEditingOrder={closeModal}
      >
        <OrderFlow />
      </OrderManagementProvider>
    </div>
  );
}

export default OrderList
